import { render, staticRenderFns } from "./InvestorOnboardingDocumentsIdVerification.vue?vue&type=template&id=3d2d1d4e&"
import script from "./InvestorOnboardingDocumentsIdVerification.vue?vue&type=script&lang=js&"
export * from "./InvestorOnboardingDocumentsIdVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports